var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 100,
    viewBox: "0 0 72 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 13,
    fill: "#F3F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6553 89.46C20.6553 91.224 21.7173 92.376 23.7333 92.862L25.9113 93.402C27.2973 93.726 27.9453 94.482 27.9453 95.634C27.9453 97.11 26.7393 98.028 24.8493 98.028C23.0853 98.028 21.8973 97.146 21.8253 95.796H20.4933C20.6553 97.902 22.3473 99.216 24.8493 99.216C27.5133 99.216 29.2413 97.794 29.2413 95.562C29.2413 93.816 28.1973 92.664 26.1813 92.178L23.9673 91.638C22.6173 91.296 21.9513 90.576 21.9513 89.442C21.9513 87.984 23.1393 87.048 24.9573 87.048C26.5773 87.048 27.5673 87.876 27.7113 89.334H29.0253C28.8273 87.174 27.2973 85.878 24.9753 85.878C22.3833 85.878 20.6553 87.3 20.6553 89.46ZM36.4859 94.266C38.9519 94.266 40.5359 92.502 40.5359 90.162C40.5359 87.732 38.9699 86.112 36.4859 86.112H31.5719V99H32.8679V94.266H36.4859ZM36.3059 87.282C38.0879 87.282 39.1859 88.362 39.1859 90.144C39.1859 91.908 38.1059 93.096 36.2339 93.096H32.8679V87.282H36.3059ZM42.1012 99L43.3612 95.58H49.3012L50.5612 99H51.9112L47.1232 86.112H45.5212L40.7872 99H42.1012ZM46.1512 87.93C46.2232 87.75 46.2952 87.516 46.3132 87.408C46.3312 87.534 46.4212 87.75 46.4752 87.93L48.8872 94.446H43.7572L46.1512 87.93Z",
    fill: "#303030"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2002,
    y: 13.1992,
    width: 45.6,
    height: 45.6,
    rx: 3.95833,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9004,
    y: 19.373,
    width: 11.875,
    height: 8.075,
    rx: 1.97917,
    fill: "#D0D7FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5752,
    y: 19.373,
    width: 18.525,
    height: 33.725,
    rx: 1.97917,
    fill: "#2342E6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9004,
    y: 32.1992,
    width: 11.875,
    height: 8.075,
    rx: 1.97917,
    fill: "#D0D7FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9004,
    y: 45.0234,
    width: 11.875,
    height: 8.075,
    rx: 1.97917,
    fill: "#D0D7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpa);
export default __webpack_public_path__ + "static/media/SPA.70897c1da3df9957d24f5f9ab64f2883.svg";
export { ForwardRef as ReactComponent };